import { Link, Outlet, useLocation } from 'react-router-dom'
import { ShoppingBag, CalendarDays, UserRound } from 'lucide-react'
import { useTenant } from '../../contexts/TenantContext'
import { useCart } from '../../contexts/CartContext'
import { useTheme } from '../../contexts/ThemeContext'
import { skinFor, brandStyle } from '../../pages/customer/templates/shared'
import CartBottomBar from '../CartBottomBar'
import CartDrawer from '../CartDrawer'
import SocialLinks from '../SocialLinks'
import { LanguageSwitcher } from '../../i18n'
import { t } from '../../i18n'
export default function CustomerLayout() {
 const tenant = useTenant()
 const { itemCount, openDrawer } = useCart()
 const { getAppName } = useTheme()
 const location = useLocation()
 const booking = ['appointments','hotel','office'].includes(tenant.businessType)
 const name = tenant.name || getAppName()
 const customTheme = tenant.settings?.custom_theme?.active ? tenant.settings.custom_theme : null
 // An uploaded theme's colors win over the template's skin colors; without
 // one, the skin's own tokens (index.css) apply.
 const themeStyle = customTheme ? Object.fromEntries(Object.entries({
  '--theme-primary': customTheme.colors?.primary,
  '--theme-secondary': customTheme.colors?.secondary,
  '--theme-accent': customTheme.colors?.accent,
  '--theme-background': customTheme.colors?.background,
  '--theme-text': customTheme.colors?.text
 }).filter(([, v]) => v)) : brandStyle(tenant.settings)
 const social = tenant.settings?.social_links
 const query = location.search
 if (location.pathname === '/' && !tenant.loading && !tenant.found) return <Outlet />
 return <div className="customer-site" data-skin={skinFor(tenant)} style={themeStyle} data-uploaded-theme={customTheme?.id}>
  <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:start-2 focus:z-50 bg-white p-3">{t("Skip to content")}</a>
  <header className="store-header"><div className="store-header-inner"><Link to={`/${query}`} className="store-brand">{(customTheme?.logoUrl || tenant.logoUrl) ? <img src={customTheme?.logoUrl || tenant.logoUrl} alt=""/> : <span className="store-monogram">{name.charAt(0)}</span>}<span>{name}</span></Link>
    <nav aria-label={t("Main navigation")} className="flex items-center gap-2 sm:gap-5">
     <div className="hidden lg:block"><SocialLinks links={social} size={16} /></div>
     <LanguageSwitcher />
     {!booking && <Link to={`/${query}`} className="hidden sm:block text-sm">{tenant.businessType === 'ecommerce' ? t("Collection") : t("Menu")}</Link>}
     {tenant.businessType === 'restaurant' && tenant.settings?.reservations_enabled !== false && <Link to={`/reservations${query}`} className="store-nav-action"><CalendarDays size={18}/><span className="hidden sm:inline">{t("Reserve a table")}</span></Link>}
     <Link aria-label={t("Your account")} to={`/account${query}`} className="store-nav-action"><UserRound size={19}/></Link>
     {!booking && (tenant.businessType === 'ecommerce' ? (
       <button aria-label={t("Open cart")} onClick={openDrawer} className="store-nav-action"><ShoppingBag size={19}/><span>({itemCount})</span></button>
     ) : (
       <Link to={`/cart${query}`} className="store-nav-action"><ShoppingBag size={19}/><span>({itemCount})</span></Link>
     ))}
    </nav></div></header>
  <main id="main-content" className="store-main"><Outlet /></main>
  <footer className="store-footer">
   <div><Link to={`/${query}`} className="font-semibold">{name}</Link><p className="mt-1">© {new Date().getFullYear()} {name}</p></div>
   <SocialLinks links={social} />
   {!booking && <Link to={`/order-status${query}`}>{t("Track an order")}</Link>}
  </footer>
  <CartBottomBar />
  {tenant.businessType === 'ecommerce' && <CartDrawer />}
 </div>
}
